import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Prose, ProseProps } from './Prose';

export interface StandaloneProseProps extends StandaloneComponentProps {
  markup?: ProseProps['markup'];
  options?: Omit<ProseProps, 'markup'>;
}

export const StandaloneProse: StandaloneComponent<StandaloneProseProps> = ({ markup, options, ...props }) => {
  return <Prose {...{ markup }} {...options} {...props} />;
};

export default StandaloneProse;
